
  import atlas from "@/components/atlas.vue";
  import { eventUploadMixin } from '@/plugins/hwtag/events';
  export default {
    mixins: [eventUploadMixin],
    data() {
      return {
        navId: 0,
        tab: 0,
        navActive:'winner',
        activeTab: 0,
        activeTab2: 0,
        // 屏幕滚动
        scrollTop: 0,
        currentPage: 1,
        source: '',
        bannerH: 0,
        headerH: 0,
        WindowWidth:'',
        imgUrl: 'https://resource.xp-pen.com/img/Contest/springContest2026/',
        sidebar: 'en',
        email: "",
        emailError: "",
        successTimer: null,
        successVisible: false,
        submitDebounce: false,
        sliderList: [
          {
            type: 'en',
            lang: 'English'
          },
          {
            type: 'de',
            lang: 'Deutsch'
          },
          {
            type: 'es',
            lang: 'Español'
          },
          {
            type: 'pt',
            lang: 'Português'
          },
          {
            type: 'it',
            lang: 'Italiano'
          },
          {
            type: 'fr',
            lang: 'Français'
          }
        ],
      };
    },
    head() {
      // 优化seo：动态设置title，keywords 和 description
      return {
        title: "The Gentle Illusion of Spring",
        meta: [
          {
            name: "keywords",
            content: "2026, XPPen, Drawing Contest, The Gentle Illusion of Spring",
          },
          {
            hid: "description",
            name: "names",
            content: "Spring is a season of renewal, where gentleness and lightness come alive around us.",
          },
        ],
      };
    },
    components: { atlas },
    computed: {},
    watch: {
      sidebar: {
        handler: function (val) {
          this.$i18n.locale = val
        },
        deep: true,
        immediate: true
      }
    },
    mounted() {
      this.WindowWidth = window.innerWidth;
      this.calculateBannerHeight();
      window.addEventListener('scroll', this.handleScroll, true);
      window.addEventListener('load', this.calculateBannerHeight); // Recalculate after all assets load
      window.addEventListener('resize', this.calculateBannerHeight);
      this.parametricWork();
      this.updateNavActive();
      if (this.$route.query.lang) {
        let lang = this.$route.query.lang;
        this.changeLanguage(lang);
      }
    },
    beforeDestroy() {
      window.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('load', this.calculateBannerHeight);
      window.removeEventListener('resize', this.calculateBannerHeight);
    },
    methods: {
      calculateBannerHeight() {
        if (this.$refs.bannerHeight) {
          this.bannerH = this.$refs.bannerHeight.offsetHeight;
        }
        if (document.getElementsByTagName('header')[0]) {
          this.headerH = document.getElementsByTagName('header')[0].offsetHeight;
        }
        this.updateNavActive();
      },
      // 作品方法
      async parametricWork(type, page = 1) {
        let res = await this.$global.parametricWork({ "activityId": 61, "page": page, "award": 0 });
        this.source = res;
      },
      // 分页
      handleCurrentChange(val) {
        this.currentPage = val;
        this.parametricWork(28, this.currentPage);
      },
      // 滚动方法
      handleScroll() {
        this.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
        this.updateNavActive();
      },
      // 更新导航激活状态
      updateNavActive() {
        const sections = [
          { id: 'winner', nav: 'winner' },
          { id: 'contestInfo', nav: 'contestInfo' },
          { id: 'terms', nav: 'terms' },
          { id: 'gallery', nav: 'gallery' }
        ];

        const navContent = document.getElementById('navContent');
        const navHeight = navContent ? navContent.offsetHeight : 0;
        const headerHeight = this.headerH;

        let activeNav = '';
        // 考虑固定导航栏和头部的高度，以及一个小的偏移量，使高亮更平滑
        const scrollPosition = this.scrollTop + navHeight + headerHeight + 1;

        for (let i = sections.length - 1; i >= 0; i--) {
          const sectionElement = document.getElementById(sections[i].id);
          if (sectionElement) {
            const sectionTop = sectionElement.offsetTop - 100;
            const sectionBottom = sectionTop + sectionElement.offsetHeight;

            if (scrollPosition >= sectionTop && scrollPosition < sectionBottom) {
              activeNav = sections[i].nav;
              break;
            }
          }
        }
        this.navActive = activeNav;
      },
      //侧边导航锚点滚动
      handleScrollTo(id) {
        const element = document.getElementById(id);
        const navHeight = document.getElementById('navContent');
        const top = (element.getBoundingClientRect().top + window.pageYOffset) - navHeight.offsetHeight - 100;
        window.scroll({ top, behavior: 'smooth' });
        this.navActive = id;
        if(id === 'winner') {
          this.navId = 0;
        }else {
          this.navId = 1;
        }
      },
      //语言栏切换
      changeLanguage(lang) {
        this.sidebar = lang;
        this.$loadLanguageAsync(lang);
      },
      //rules tab
      handelTab (tabIndex) {
        this.tab = tabIndex;
      },
      // 注册
      handelReg () {
        if(!this.$store.state.isLogin) {
          this.$jumpTerminus(2);
        }
      },
      // rules tab
      handleTab (tabIndex) {
        this.tab = tabIndex;
      },
      copyText(text) {
        // 使用现代的 Clipboard API
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(text)
            .then(() => {
              this.$message({
                message: 'Copy successful', // Copy successful
                type: 'success'
              });
            })
            .catch(err => {
              console.error('无法复制文本到剪贴板:', err); // Could not copy text:
              this.$message({
                message: 'Copy failed, please copy manually', // Copy failed, please copy manually
                type: 'error'
              });
            });
        } else {
          // 兼容旧浏览器，使用 document.execCommand
          const input = document.createElement('input');
          input.setAttribute('readonly', 'readonly');
          input.setAttribute('value', text);
          document.body.appendChild(input);
          input.select();
          try {
            const successful = document.execCommand('copy');
            if (successful) {
              this.$message({
                message: 'Copy successful', // Copy successful
                type: 'success'
              });
            } else {
              this.$message({
                message: 'Copy failed, please copy manually', // Copy failed, please copy manually
                type: 'error'
              });
            }
          } catch (err) {
            console.error('无法复制文本到剪贴板:', err); // Could not copy text:
            this.$message({
              message: 'Copy failed, please copy manually', // Copy failed, please copy manually
              type: 'error'
            });
          }
          document.body.removeChild(input);
        }
      }
    },
  };
  